<div class="full-page w-100">
  <div class="login-page">
    <img alt="" class="card-logo" src="assets/images/login-registration/login-logo.svg" draggable="false" />

    <div class="login-page-div bg-white rounded-4">
      <h5 class="login-title">{{ 'login.form.title' | translate }}</h5>
      <div class="panel-text mlb-text font-size-14">
        {{ 'login.page.description' | translate }}
      </div>
      <!-- Login Form -->
      <fgb-mlbam-user-login></fgb-mlbam-user-login>

      <!-- Registration Details -->
      <a [routerLink]="['/register/new-member']">
        <div class="btn btn-white border-disabled btn-block create-account-button w-100 font-size-14 fw-bold rounded-4">
          <span class="text-primary">{{ 'login.page.create.account.description' | translate }}</span>
        </div>
      </a>

      <div class="separator pt-1">
        <span class="mx-2 seperator-text">{{ 'login.seperator' | translate }}</span>
      </div>

      <!-- Receive partner membership -->
      <a [routerLink]="['/register/partner']">
        <div class="btn btn-tertiary btn-block create-account-button w-100 font-size-14 fw-bold rounded-4">
          <span class="text-white">{{ 'login.page.create.account.button' | translate }}</span>
        </div>
      </a>

      <a href="https://www.mlb.com/twins/fans/mytwins-membership-rewards-sweepstakes" target="_blank">
        <div class="btn btn-block w-100 font-size-14 fw-bold rounded-4 border-disabled">
          <span class="text-black">{{ 'sweepstakes.rules.button' | translate }}</span>
        </div>
      </a>

      <a [routerLink]="['/register/referafriend']">
        <div class="btn btn-block w-100 font-size-14 fw-bold rounded-4 border-disabled">
          <span>{{ 'received.friend.invitation.button' | translate }}</span>
        </div>
      </a>
    </div>
  </div>
</div>
<fgbcl-preview />
